module Meevo.Plugins.Register {
    "use strict";
    export class RefundOptionsSection extends Meevo.Plugins.Register.RegisterSectionBase {
        giftCardSecurityKey: string;
        
        constructor(registerContext: Meevo.Plugins.Register.RegisterContext) {
            super(RegisterSectionTypeEnum.RefundOptions, registerContext, "refundOptions", Register.RegisterSectionCatTypeEnum.Sale);
            const singleGiftCardKey = Meevo.Components.Common.SecurityKeys.REGISTER_REGISTER_ACTION_REFUNDGIFTCARD;
            const bulkGiftCardKey = Meevo.Components.Common.SecurityKeys.REGISTER_REGISTER_ACTION_REFUNDBULKGIFTCARD;
            let keysToCheck: string[] = [
                singleGiftCardKey,
                bulkGiftCardKey,
            ];

            this.registerContext.securityService.checkAndCache(keysToCheck).then((response) => {
                let canRefundSingle = _(response).findWhere({ key: singleGiftCardKey });
                let canRefundBulk = _(response).findWhere({ key: bulkGiftCardKey });

                // default to a key that has grant so that button can be clicked
                this.giftCardSecurityKey = Meevo.Components.Common.SecurityKeys.REGISTER;
                if (canRefundSingle.securityAccess === Meevo.Model.SecurityAccessEnum.Grant &&
                    canRefundBulk.securityAccess === Meevo.Model.SecurityAccessEnum.Hide) {
                }
                else if (canRefundSingle.securityAccess === Meevo.Model.SecurityAccessEnum.Deny &&
                    canRefundBulk.securityAccess === Meevo.Model.SecurityAccessEnum.Hide) {
                    this.giftCardSecurityKey = singleGiftCardKey;
                }
                else if (canRefundSingle.securityAccess === Meevo.Model.SecurityAccessEnum.Hide) {
                    switch (canRefundBulk.securityAccess) {
                        case Meevo.Model.SecurityAccessEnum.Deny:
                        case Meevo.Model.SecurityAccessEnum.Hide:
                            this.giftCardSecurityKey = bulkGiftCardKey;
                            break;
                    }
                }
            });
        }


    }
}